import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: UserState = {
    auth: undefined,
    token: localStorage.getItem(`${process.env.VUE_APP_NAME}_bearerToken`),
};

const rootState: UserState = initialState;

const getters: GetterTree<UserState, RootState> = {
    isLoggedIn(state: UserState): boolean {
        return !!state.token;
    },
    auth(state: UserState): User | undefined {
        return state.auth;
    },
};

const mutations: MutationTree<UserState> = {
    SET_TOKEN(state: UserState, token: string) {
        localStorage.setItem(`${process.env.VUE_APP_NAME}_bearerToken`, token);
        state.token = token;
    },
    SET_AUTH(state: UserState, payload: User) {
        state.auth = payload;
    },
    RESET(state: UserState) {
        localStorage.removeItem(`${process.env.VUE_APP_NAME}_bearerToken`);
        state.token = null;
        Object.assign(state, initialState);
    },
};

const actions: ActionTree<UserState, RootState> = {
    login({ commit }, payload: ApiRequestAccessToken): any {
        // @ts-ignore
        return this._vm.$api.post('auth/access_token', payload)
            .then((data: ApiResponseAccessToken) => {
                // @ts-ignore
                this._vm.$api.defaults.headers.common.Authorization = `Bearer ${data.data.Token}`;

                commit('SET_TOKEN', data.data.Token);

                return Promise.resolve();
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    me({ commit }): any {
        // @ts-ignore
        return this._vm.$api.get('me')
            .then((data: ApiResponseUser) => {

                commit('SET_AUTH', data.data);

                return Promise.resolve();
            })
            .catch((e: any) => {
                if (e.response.status === 401) {
                    return Promise.reject(e.response.status);
                }
                return Promise.reject([e.response.data]);
            });
    },
    passwordForgot({ commit }, payload: object): any {
        // @ts-ignore
        return this._vm.$api.post('auth/pwd/link', payload)
            .then((data: ApiResponseUser) => {
                return Promise.resolve(data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
    passwordReset({ commit }, payload: object): any {
        // @ts-ignore
        return this._vm.$api.post('auth/pwd/reset', payload)
            .then((data: ApiResponseUser) => {
                return Promise.resolve(data);
            })
            .catch((e: any) => {
                return Promise.reject([e.response.data]);
            });
    },
};

export default {
    namespaced: true,
    state: rootState,
    getters,
    actions,
    mutations,
};
